export const getInitialState = () => ({});
